import useAPI from '@/hooks/useAPI';
import StaffRepository from '@/repositories/StaffRepository';
import { StaffFilters } from '@/types/person';

const useStaff = ({
  enabled = true,
  withHealthieId,
  withKustomerId
}: { enabled?: boolean; withHealthieId?: boolean; withKustomerId?: boolean } = {}) => {
  const staffRepository = StaffRepository();
  const params: StaffFilters = {};

  if (withHealthieId !== undefined) {
    params.healthie_id__isnull = !withHealthieId;
  }
  if (withKustomerId !== undefined) {
    params.kustomer_id__isnull = !withKustomerId;
  }

  return useAPI({
    queryKey: ['getStaff', params],
    queryFn: async () => {
      return await staffRepository.getStaffList(params);
    },
    enabled
  });
};

export default useStaff;
